export default __webpack_public_path__ + "static/media/no_message.059994f9.svg";